import { call, ensureCsrf, type Failure } from './apiCall';

/**
 * Gửi báo lỗi lên máy chủ.
 *
 * Mỏng như `accountService`, và có đúng hai việc mà tầng này phải làm — cả hai đều là những thứ
 * chỉ trình duyệt mới biết.
 *
 * **Xin mã CSRF trước.** Mã được phát ra ở một lần đọc. Hộp thoại tài khoản gọi `GET /v1/me` khi
 * nó mở ra, nhưng người báo lỗi có thể chưa từng mở hộp thoại đó — họ vừa vào, gặp lỗi, và bấm
 * nút báo lỗi. Không có `ensureCsrf`, chính báo cáo đó nhận về 403.
 *
 * **Bối cảnh được thu ở đây, không phải trong hộp thoại.** Bản dựng và cỡ màn hình là chuyện của
 * trình duyệt; một component không nên biết `__BUILD__` là gì, và một cổng (port) thì càng không.
 *
 * Kiểu dữ liệu được khai lại chứ không import từ `@/ui/reportPort`, vì `src/infrastructure` không
 * được với sang `src/ui` (ADR‑0001) — chiều phụ thuộc chỉ đi một hướng. `accountService` cũng khai
 * lại đúng như vậy; chỗ khớp hai bên lại với nhau là gốc lắp ráp, và trình biên dịch kiểm hộ.
 */

export interface ReportDraft {
  readonly description: string;
  readonly drawing: string | null;
  readonly drawingBytes: number | null;
}

/** Trần của máy chủ, lặp lại ở đây để hộp thoại nói trước được thay vì chờ bị từ chối. */
export const MAX_DRAWING_BYTES = 1024 * 1024;

export async function sendReport(draft: ReportDraft): Promise<{ id: string } | Failure> {
  await ensureCsrf();

  return call<{ id: string }>('/v1/reports', {
    body: {
      description: draft.description,
      drawing: draft.drawing,
      drawingBytes: draft.drawingBytes,
      appVersion: __BUILD__,
      /*
       * Cỡ cửa sổ, không phải cỡ màn hình.
       *
       * Lỗi bố cục xảy ra ở cái khung mà bản vẽ thực sự nằm trong, và một màn hình 2560 rộng
       * không nói gì về một cửa sổ bị kéo còn một nửa — mà đúng cái nửa đó mới là chỗ thanh
       * công cụ chồng lên nhau.
       */
      viewport: `${String(globalThis.innerWidth)}×${String(globalThis.innerHeight)}`,
    },
  });
}
